import PortailHomeController from './portail.home.controller';

export default {
    controller: PortailHomeController,
    template: require('./portail.home.tpl.html')
};
